import { RouteParameters } from "./route-parameters";

const MAINTENANCE_INTELLIGENCE_ROUTING = {
  EXPORT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/maintenance-intelligence/export`,
  IMPORT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/maintenance-intelligence/import`,
  INITIALIZE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/maintenance-intelligence/initialize`,
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/maintenance-intelligence`,
  VIEW: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/maintenance-intelligence/view`,
} as const;

const MAINTENANCE_INTELLIGENCE_ROUTES = [
  MAINTENANCE_INTELLIGENCE_ROUTING.ROOT,
  MAINTENANCE_INTELLIGENCE_ROUTING.EXPORT,
  MAINTENANCE_INTELLIGENCE_ROUTING.IMPORT,
  MAINTENANCE_INTELLIGENCE_ROUTING.VIEW,
  MAINTENANCE_INTELLIGENCE_ROUTING.INITIALIZE,
] as const;

export { MAINTENANCE_INTELLIGENCE_ROUTES, MAINTENANCE_INTELLIGENCE_ROUTING };
